import { boot } from 'quasar/wrappers'
import * as Sentry from "@sentry/vue";

import {
  // createSharedElementDirective,
  SharedElementRouteGuard,
  SharedElementDirective
} from 'v-shared-element'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot( ({ app, router }) => {

  // Sentry.init({
  //   app,
  //   dsn: "https://04ddfcab954f115ed4324440c7a5d98c@o4508881215815680.ingest.us.sentry.io/4508881219223552",
  //   integrations: [
  //     Sentry.browserTracingIntegration({ router }),
  //     Sentry.replayIntegration(),
  //   ],
  //   // Tracing
  //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //   tracePropagationTargets: ["api.form-data.com"],
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // });
})
